<template>
  <div class="quiz-screen">
    <!-- Top bar -->
    <div class="quiz-top">
      <button class="btn-back" @click="confirmBack">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
          stroke-linecap="round" stroke-linejoin="round">
          <polyline points="15 18 9 12 15 6"/>
        </svg>
      </button>
      <div class="quiz-progress-wrap">
        <div class="q-label">Savol {{ qIndex + 1 }} / {{ questions.length }}</div>
        <div class="progress-bar">
          <div class="progress-fill" :style="{ width: progressPct + '%' }"></div>
        </div>
      </div>
      <div class="q-timer" :class="{ danger: timeLeft <= 5 }">{{ timeLeft }}</div>
    </div>

    <!-- Question card -->
    <div class="quiz-card" :key="qIndex">
      <div class="q-num">SAVOL {{ qIndex + 1 }}</div>
      <div class="q-text">{{ currentQ.q }}</div>
    </div>

    <!-- Options -->
    <div class="options">
      <div
        v-for="(opt, i) in currentQ.opts"
        :key="i"
        class="opt-btn"
        :class="optClass(i)"
        @click="selectAnswer(i)"
      >
        <div class="opt-letter">{{ letters[i] }}</div>
        <div class="opt-text">{{ opt }}</div>
      </div>
    </div>

    <!-- Feedback -->
    <transition name="slide-up">
      <div v-if="feedback.show" class="feedback-toast" :class="feedback.type">
        {{ feedback.msg }}
      </div>
    </transition>
  </div>
</template>

<script>
import { QUESTIONS } from '../../data/questions'

export default {
  name: 'QuizView',
  emits: ['back', 'finish'],

  props: {
    catKey: { type: String, required: true },
    catName: { type: String, required: true },
    catEmoji: { type: String, required: true },
  },

  data() {
    return {
      letters: ['A', 'B', 'C', 'D'],
      questions: [],
      qIndex: 0,
      correct: 0,
      wrong: 0,
      points: 0,
      answered: false,
      selectedIdx: null,
      timeLeft: 15,
      timer: null,
      feedback: { show: false, msg: '', type: '' },
    }
  },

  computed: {
    currentQ() {
      return this.questions[this.qIndex] || { q: '', opts: [] }
    },
    progressPct() {
      return ((this.qIndex + 1) / this.questions.length) * 100
    },
  },

  methods: {
    optClass(i) {
      if (!this.answered) return ''
      if (i === this.currentQ.ans) return 'correct disabled'
      if (i === this.selectedIdx && i !== this.currentQ.ans) return 'wrong disabled'
      return 'disabled'
    },

    startTimer() {
      clearInterval(this.timer)
      this.timeLeft = 15
      this.timer = setInterval(() => {
        this.timeLeft--
        if (this.timeLeft <= 0) {
          clearInterval(this.timer)
          if (!this.answered) this.autoTimeout()
        }
      }, 1000)
    },

    autoTimeout() {
      this.answered = true
      this.wrong++
      this.selectedIdx = -1
      this.showFeedback(false, '⏰ Vaqt tugadi!')
      setTimeout(this.nextQ, 1600)
    },

    selectAnswer(idx) {
      if (this.answered) return
      this.answered = true
      this.selectedIdx = idx
      clearInterval(this.timer)

      const isCorrect = idx === this.currentQ.ans
      if (isCorrect) {
        this.correct++
        this.points += 10 + this.timeLeft
        this.showFeedback(true, "✅ To'g'ri javob!")
      } else {
        this.wrong++
        this.showFeedback(false, "❌ Noto'g'ri! To'g'ri javob belgilandi.")
      }
      setTimeout(this.nextQ, 1600)
    },

    showFeedback(isCorrect, msg) {
      this.feedback = { show: true, msg, type: isCorrect ? 'correct' : 'wrong' }
    },

    nextQ() {
      this.feedback.show = false
      this.qIndex++
      if (this.qIndex >= this.questions.length) {
        this.endQuiz()
        return
      }
      this.answered = false
      this.selectedIdx = null
      this.startTimer()
    },

    endQuiz() {
      clearInterval(this.timer)
      this.$emit('finish', {
        correct: this.correct,
        wrong: this.wrong,
        total: this.questions.length,
        points: this.points,
        catName: this.catName,
        catEmoji: this.catEmoji,
      })
    },

    confirmBack() {
      clearInterval(this.timer)
      this.$emit('back')
    },

    initQuiz() {
      this.questions = [...QUESTIONS[this.catKey]].sort(() => Math.random() - 0.5)
      this.qIndex = 0
      this.correct = 0
      this.wrong = 0
      this.points = 0
      this.answered = false
      this.selectedIdx = null
      this.feedback = { show: false, msg: '', type: '' }
      this.startTimer()
    },
  },

  mounted() {
    this.initQuiz()
  },

  beforeUnmount() {
    clearInterval(this.timer)
  },
}
</script>
